// extracted by mini-css-extract-plugin
export default {"settingsMenu":"settingsMenu--IXF_M","settingsMenuItem":"settingsMenuItem--JvUtc","wizardQuestionaryHeaderButton":"wizardQuestionaryHeaderButton--Rr1jS","textWrap":"textWrap--qS04l"};